// extracted by mini-css-extract-plugin
export var deleteModal = "_j9-0";